import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ColorsModule } from '@plugins/client/colors/colors.module';
import { ConfirmDialogModule } from '@plugins/client/confirm-dialog/confirm-dialog.module';
import { SubmitColorChangeDirective } from '@plugins/client/directives/submit-color-change.directive';
import { MultilanguageModule } from '@plugins/client/multilanguage/multilanguage.module';
import { TranslateDatePipe } from '@plugins/client/pipes/translate/translate-date.pipe';
import { TranslatePipe } from '@plugins/client/translate/pipes';
import { UserDetailsModule } from '@plugins/userdetails-client';

import { AnswerStatusComponent } from './components/answer-status/answer-status.component';
import { QuestionStatusComponent } from './components/question-status/question-status.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { StatusPipe } from './pipes/status.pipe';

const components = [
  StatusIconComponent,
  AnswerStatusComponent,
  QuestionStatusComponent,
];

const angularModules = [CommonModule, ReactiveFormsModule];

const customModules = [ColorsModule, ConfirmDialogModule, MultilanguageModule];

const moduleDefinedPipes = [StatusPipe];

@NgModule({
  imports: [
    ...angularModules,
    ...customModules,
    TranslateDatePipe,
    SubmitColorChangeDirective,
    UserDetailsModule,
    TranslatePipe,
  ],
  declarations: [...components, ...moduleDefinedPipes],
  exports: [
    CommonModule,
    TranslateDatePipe,
    ColorsModule,
    ...components,
    ...moduleDefinedPipes,
    TranslatePipe,
    SubmitColorChangeDirective,
    UserDetailsModule,
    MultilanguageModule,
  ],
})
export class SharedModule {}
